import { useEffect, useMemo } from 'react';
import Layout from '@layout/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import EpubNotes from '@cont/EpubNotes/EpubNotes';
import {
  findFirstEnabledConcept,
  getConceptListEndpoint
} from '@cont/EpubNotes/utils';
import {
  getIsSubscribedToGoal,
  getIsUserSubscribedToDigitalNotes
} from '@api/selectors/subscription';
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getMe, getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';
import { useRouter } from 'next/router';

const EpubNotesPage = () => {
  const router = useRouter();
  const { topicUID, goalUID } = router.query;
  const { data = {} } = useFetch(getConceptListEndpoint(topicUID));
  const { children = [] } = data;
  const conceptDetails = findFirstEnabledConcept(children);
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const meInfo = useMyInfo(getMe);
  const isSubscribed = useMemo(
    () => getIsSubscribedToGoal(goalUID)(meInfo),
    [meInfo, goalUID]
  );
  const isSubscribedToNotes = useMyInfo(
    getIsUserSubscribedToDigitalNotes(goalUID, '502')
  );

  useEffect(() => {
    if (isLoggedIn && meInfo && !isSubscribed && !isSubscribedToNotes) {
      router.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, isSubscribed, isSubscribedToNotes]);
  if (!data.name) return null;
  return <EpubNotes selectedConcept={conceptDetails} />;
};

EpubNotesPage.pageInfo = {
  isMWebSupported: false,
  name: 'Epub Notes Page',
  isProtected: true,
  layoutOptions: {
    showPlusNav: false,
    hideFooter: true,
    hideHeader: true,
    fullHeightContent: true,
    hideSearch: true,
    hideIntercom: true,
    disableDarkMode: false
  }
};

export const getStaticProps = async ({ params: query }) => {
  const { goalUID, topicUID } = query;
  if (!goalUID || !topicUID)
    return {
      redirect: { destination: '/404' }
    };

  return {
    props: {}
  };
};

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking'
  };
};

EpubNotesPage.Layout = Layout;

export default EpubNotesPage;
EpubNotesPage.Wrapper = PageReduxProvider;
